import { l as t } from "./_commonjsHelpers-b0e8727a.js";

var n = function n(t) {
  var n = typeof t;
  return null != t && ("object" == n || "function" == n);
},
    e = "object" == typeof t && t && t.Object === Object && t,
    r = "object" == typeof self && self && self.Object === Object && self,
    o = e || r || Function("return this")(),
    i = function i() {
  return o.Date.now();
},
    a = o.Symbol,
    u = Object.prototype,
    c = u.hasOwnProperty,
    f = u.toString,
    l = a ? a.toStringTag : void 0;

var v = function v(t) {
  var n = c.call(t, l),
      e = t[l];

  try {
    t[l] = void 0;
    var r = !0;
  } catch (t) {}

  var o = f.call(t);
  return r && (n ? t[l] = e : delete t[l]), o;
},
    s = Object.prototype.toString;

var p = function p(t) {
  return s.call(t);
},
    b = "[object Null]",
    d = "[object Undefined]",
    m = a ? a.toStringTag : void 0;

var y = function y(t) {
  return null == t ? void 0 === t ? d : b : m && m in Object(t) ? v(t) : p(t);
};

var j = function j(t) {
  return null != t && "object" == typeof t;
},
    g = "[object Symbol]";

var O = function O(t) {
  return "symbol" == typeof t || j(t) && y(t) == g;
},
    T = NaN,
    h = /^\s+|\s+$/g,
    S = /^[-+]0x[0-9a-f]+$/i,
    x = /^0b[01]+$/i,
    w = /^0o[0-7]+$/i,
    $ = parseInt;

var N = function N(t) {
  if ("number" == typeof t) return t;
  if (O(t)) return T;

  if (n(t)) {
    var e = "function" == typeof t.valueOf ? t.valueOf() : t;
    t = n(e) ? e + "" : e;
  }

  if ("string" != typeof t) return 0 === t ? t : +t;
  t = t.replace(h, "");
  var r = x.test(t);
  return r || w.test(t) ? $(t.slice(2), r ? 2 : 8) : S.test(t) ? T : +t;
},
    E = "Expected a function",
    M = Math.max,
    W = Math.min;

var D = function D(t, e, r) {
  var o,
      a,
      u,
      c,
      f,
      l,
      v = 0,
      s = !1,
      p = !1,
      b = !0;
  if ("function" != typeof t) throw new TypeError(E);

  function d(n) {
    var e = o,
        r = a;
    return o = a = void 0, v = n, c = t.apply(r, e);
  }

  function m(t) {
    var n = t - l;
    return void 0 === l || n >= e || n < 0 || p && t - v >= u;
  }

  function y() {
    var t = i();
    if (m(t)) return j(t);
    f = setTimeout(y, function (t) {
      var n = e - (t - l);
      return p ? W(n, u - (t - v)) : n;
    }(t));
  }

  function j(t) {
    return f = void 0, b && o ? d(t) : (o = a = void 0, c);
  }

  function g() {
    var t = i(),
        n = m(t);

    if (o = arguments, a = this, l = t, n) {
      if (void 0 === f) return function (t) {
        return v = t, f = setTimeout(y, e), s ? d(t) : c;
      }(l);
      if (p) return clearTimeout(f), f = setTimeout(y, e), d(l);
    }

    return void 0 === f && (f = setTimeout(y, e)), c;
  }

  return e = N(e) || 0, n(r) && (s = !!r.leading, u = (p = "maxWait" in r) ? M(N(r.maxWait) || 0, e) : u, b = "trailing" in r ? !!r.trailing : b), g.cancel = function () {
    void 0 !== f && clearTimeout(f), v = 0, o = l = a = f = void 0;
  }, g.flush = function () {
    return void 0 === f ? c : j(i());
  }, g;
};

export { a as S, j as a, y as b, O as c, D as d, D as e, e as f, n as i, o as r };